import {getUrlParam} from '../_components/_get-url-params';

const CAMPAIGN = 'input[name="utm_campaign"]';
const MEIDUM = 'input[name="utm_medium"]';
const SOURCE = 'input[name="utm_source"]';

window.addEventListener('message', event => {
    if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
        if (document.querySelector(CAMPAIGN)) {
            let campaign = document.querySelector(CAMPAIGN);
            var utm_campaign = getUrlParam( "utm_campaign", 0 );
            if ( utm_campaign ) {
                campaign.value = utm_campaign;
            }
        }
        if (document.querySelector(MEIDUM)) {
            let medium = document.querySelector(MEIDUM);
            var utm_medium = getUrlParam( "utm_medium", 0 );
            if ( utm_medium ) {
                medium.value = utm_medium;
            }
        }
        if (document.querySelector(SOURCE)) {
            let source = document.querySelector(SOURCE);
            var utm_source = getUrlParam( "utm_source", 0 );
            if ( utm_source ) {
                source.value = utm_source;
            }
        }
    }
});